import { Article, getArticleBySlug as getArticleBySlugFn, getAllCategories as getAllCategoriesFn } from '../articleTypes';

// Import individual articles
import article1 from './creating-family-trees-digital-memorials';
import article2 from './sharing-memories-cope-with-loss';
import article3 from './preserving-family-history-digital-memorials';

// Combine all articles into a single array
export const articles: Article[] = [
  article1,
  article2,
  article3
];

// Re-export helper functions with our articles array
export const getArticleBySlug = (slug: string): Article | undefined => 
  getArticleBySlugFn(articles, slug);

export const getAllCategories = (): string[] => 
  getAllCategoriesFn(articles); 